<template>
  <div>
    <div v-if="UserItems.length > 0" class="flex px-0 py-3 justify-end items-center">
      <div >
        <t-dropdown>
          <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
            class="flex z-50">
            <button
              class="flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
              @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
              <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
              </svg>
              Filter
              <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <polygon
                  points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
              </svg>
              <div v-if="dataBadge"
                  class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
                  {{ dataBadge }}
                </div>
            </button>
          </div>
          <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
            slot-scope="{ hide, blurHandler }">
            <div
              class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
              role="menuitem">
              <div class="flex justify-between">
                <div>Filter</div>
                <div @click="hide">
                  <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M6 18 17.94 6M18 18 6.06 6" />
                  </svg>
                </div>
              </div>
              <div class="flex justify-between mb-3 mt-2">
                <div class="w-full mr-2">
                  <label class="text-gray-600 font-semibold mb-3 mt-2">Content Type</label>
                  <FilterComponent v-model="contentType" :options="contentTypeOptions"
                    :defaultText="'Select Contents Package Type'" />
                </div>
              </div>
              <div class="mt-3">
                <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg" @click="filter()"
                  @blur="blurHandler">
                  Filter
                </button>
                <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="reset()"
                  @blur="blurHandler">Reset</button>
              </div>

            </div>

          </div>
        </t-dropdown>
      </div>
    </div>
    <div v-if="UserItems.length > 0" class="mt-1 border-gray-200 border-b border-t border-r border-l rounded-lg">

      <Table :headers="headers" :data="UserItems" :row-key="[
                'id',
                'orderline_id',
                'item_name',
                'item_type',
                'item_status',
                'user_buffet_id',
                'created',
                'modified',
                'actionbtnSwitch'
              ]" :current-page="currentPage" :isLoading="isLoading" :withScrollX="true" :per-page="perPage">
        <template #actionbtnSwitch="{ row }">
          <label class="switch"
          >
            <input 
            type="checkbox" 
            :checked="tempRowId === row.id ? tempIsActive : row.is_active"
              @change="onSwitchChange(row)"
              :class="{ isToggleStatus:tempRowId === row.id ? tempIsActive : row.is_active }" />
            <span class="slider"></span>
          </label>

          <t-modal ref="modalAction" @before-close="onBeforeClose">
            <div class="text-sm flex-col justify-center items-center text-center">
              <p class="text-lg  normal-case font-semibold text-gray-900 mb-2"> {{ tempIsActive ? 'Activate' : 'Deactivate' }} contents?</p>
              <div class="text-center text-base normal-case">
                Once you save this data, the status at the selected content will be updated. Please recheck.
              </div>
              <div class="flex justify-center mb-2 mt-3">
                <button @click="handleSave()"
                  class="bg-blue-700 rounded-lg px-2.5 py-2 text-white mr-3">
                  Save
                </button>
                <button @click="handleCancel" class="border px-2 py-2 rounded-lg">
                  Cancel
                </button>
              </div>
            </div>
          </t-modal>
        </template>

        <template #item_name="{ row }">
          {{ row.item.name }}
        </template>
        <template #item_type="{ row }">
          {{ row.item.item_type }}
        </template>
         <template #user_buffet_id="{ value }">
          <span v-if="value">
            Yes
          </span>
           <span v-else>
            No
          </span>
        </template>
        
        <template #item_status="{ row }">
          <span v-if="row && row.item && row.item.item_status"
            :class="getStatusClass(row.item.item_status) + ' px-2 py-1 text-sm  rounded-lg'">
            {{ row.item.item_status }}
          </span>
          <span v-else class="bg-gray-100 text-gray-600 px-2 py-1 text-sm  rounded-lg">
            -
          </span>
        </template>
 <template #header-valid-from-single="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}   
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
         <template #header-valid-to-single="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}   
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <template #created="{ row }">
         <div v-if="['book', 'magazine'].includes(row.item.item_type)">
              <span class="text-sm"> 
            {{ formatDateUTS(row.created).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDateUTS(row.created).time }}</span>
         </div>
         <div v-else>
              <span class="text-sm"> 
            {{ formatDate(row.created).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(row.created).time }}</span>
         </div>

        </template>
        <template #modified="{ row }">
          <div v-if="['book', 'magazine'].includes(row.item.item_type)">
              <span class="text-sm"> 
            {{ formatDateUTS(row.created).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDateUTS(row.created).time }}</span>
         </div>
         <div v-else>
              <span class="text-sm"> 
            {{ formatDate(row.created).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(row.created).time }}</span>
         </div>
        </template>
      </Table>
    </div>
     <div  v-else class="relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
  <table v-if="!isLoading" class="min-w-full h-64 text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center uppercase">
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">No</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">user Contents id</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">orderline key</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Contents Name
            </th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Content Type</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Content Status</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">buffets</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Created Date</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">modified Date</th>
          <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Status</th>
          
          </tr>
        </thead>
        <tbody class="bg-white w-full">
          <tr>
            <td colspan="10" class="text-center py-8 text-gray-500">
            <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 574px;">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import constant from '../../store/constant';
import Table from '@/components/form/table.vue'
import FilterComponent from '@/components/form/StatusFilterComponent.vue'
import { EventBus } from '../../event-bus'

import { mapActions, mapState } from "vuex";
export default {
  components: {
    Table,
    FilterComponent
  },
  name: "UserSingleNew",
  props: {
    user: {
      type: String,
      required: true,
    },
    UserItems: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      modal: false,
      sorts:[],
      tempIsActive: false,
      tempRowId: null,
      selectedRow: null,
      dataBadge: null,
      selectPremium: false,
      selectNonPremium: false,
      selectAll: true,
      contentType: null,
      localCurrentPage: this.currentPage,
      contentTypeOptions: [
        {
          text: 'All Content',
          value: 'all',
        },
        {
          text: 'Buffet Content',
          value: 'buffet',
        },
        {
          text: 'Single Content',
          value: 'single',
        },

      ],
      headers: [
        { label: 'No', key: '' },
        { label: 'user Contents id', key: '' },
        { label: 'orderline key', key: '' },
        { label: 'Contents Name', key: '' },
        { label: 'Content Type', key: '' },
        { label: 'Content Status', key: '', style: 'min-width:200px' },
        { label: 'buffets', key: 'user_buffet_id', },
        { label: 'Created Date',  key: 'created', slotHeader:'header-valid-from-single'},
        { label: 'modified Date',  key: 'modified', slotHeader:'header-valid-to-single' },
        { label: 'Status', key: '', }

      ],
      fields: [
        { key: 'No', style: { 'width': '5%', 'text-align': 'center' }, label: 'No' },
        { key: 'id', style: { 'width': '5%', 'text-align': 'center' }, label: 'User Items ID' },
        { key: 'orderline_id', style: { 'width': '5%', 'text-align': 'center' }, label: 'Orderline Key' },
        { key: 'item_name', style: { 'width': '20%', 'text-align': 'center' }, label: 'Items Name' },
        { key: 'item_type', style: { 'width': '5%', 'text-align': 'center' }, label: 'Item Type' },
        { key: 'item_status', style: { 'width': '5%', 'text-align': 'center' }, label: 'Item Status' },
        { key: 'user_buffet_id', style: { 'width': '5%', 'text-align': 'center' }, label: 'Buffets' },
        {
          key: 'created', label: 'Created', style: { 'width': '5%', 'text-align': 'center' }, formatter: function (value) {
            return moment(value).format('DD MMM YYYY HH:mm:ss');
          },
        },
        {
          key: 'modified', style: { 'width': '5%', 'text-align': 'center' }, label: 'Modified', formatter: function (value) {
            return moment(value).format('DD MMM YYYY HH:mm:ss');
          },
        },
        { key: 'is_active_cell', style: { 'width': '5%', 'text-align': 'center' }, label: 'Is Active' },
        { key: 'preview_image', style: { 'width': '5%', 'text-align': 'center' }, label: 'Preview Image' },

      ]
    };
  },
  computed: {
    ...mapState({
      isLoadingDelete: (state) => state.buffets.isLoadingDelete,
      message: (state) => state.buffets.message,
      countSingle: (state) => state.users.countSingle,
    })
  },
  
  methods: {
    ...mapActions("users", ["fetchSingle"]),
    ...mapActions("single", ["deactiveOrders"]),
    showModal(item) {
      this.modal = true;
      this.BuffetsDetail = item;
    },
    onSwitchChange(row) {
      this.tempRowId = row.id;
      this.tempIsActive = !row.is_active;
      this.selectedRow = row
      this.$refs.modalAction.show();
    },
      sortBy(column) {
        let existingIndex = this.sorts.findIndex(s => s.column === column);

  if (existingIndex >= 0) {
    this.sorts[existingIndex].order =
      this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

    const [item] = this.sorts.splice(existingIndex, 1);
    this.sorts.unshift(item);
  } else {
    this.sorts.unshift({ column, order: "asc" });
  }

      let sortString = this.sorts
        .map(s => `${s.column}_${s.order}`)
        .join(',');
        this.$emit("sort-data",sortString);
    },
    async handleSave() {
      const payload = {
        id:this.selectedRow.id,
        is_active: this.tempIsActive,
        user_id:this.selectedRow.user_id, 
        orderline_id:this.selectedRow.orderline_id,
      }
      await this.deactiveOrders(payload).then((response) => {
       const message = response.message;
        if(response.result){
          EventBus.$emit('show-toast', {
            message:message,
            type: 'success',
          });
            setTimeout(() => {
              this.$emit("switch-change");
              this.$refs.modalAction.hide();
            }, 500);
        }else{
          EventBus.$emit('show-toast', {
            message: message,
            type: 'error',
          });
        }
      });
    },
    onBeforeClose() {
      this.tempRowId = null;
      this.tempIsActive = false;
      this.selectedRow = null;
    },
    handleCancel() {
      this.tempRowId = null;
      this.tempIsActive = false;
      this.selectedRow = null;
      this.$refs.modalAction.hide();
    },
    reset() {
      this.contentType = null
      this.$emit('reset-filter');
      this.dataBadge = null
    },
   formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss'),
      };
  },
   formatDateUTS(tgl) {
      return {
        date: moment(tgl).utc().format('DD MMM YY'),
        time: moment(tgl).utc().format('HH:mm:ss'),
      };
  },

    getStatusClass(status) {
      const normalizedStatus = status ? status.trim().toLowerCase() : '';

      const classes = {
        'new': 'bg-blue-100 text-blue-700',
        'ready for upload': 'bg-green-100 text-green-700',
        'uploaded': 'bg-yellow-100 text-yellow-700',
        'waiting for review': 'bg-purple-100 text-purple-700',
        'rejected': 'bg-red-100 text-red-700',
        'in review': 'bg-yellow-100 text-yellow-700',
        'approved': 'bg-green-100 text-green-700',
        'prepare for consume': 'bg-yellow-100 text-yellow-700',
        'ready for consume': 'bg-blue-100 text-blue-700',
        'not for consume': 'bg-red-100 text-red-700',
        'mcgraw hill content': 'bg-gray-200 text-gray-700'
      };

      return classes[normalizedStatus] || 'bg-gray-100 text-gray-600';
    },
    previewImage(url, orderline_name) {
      const removeBucket = this.removeBucket(url)
      const basePath = constant.URL_STATIC.EBOOK_COVER
      const image = `${basePath}${removeBucket}`
      this.$swal.fire({
        title: orderline_name,
        imageUrl: image,
        imageWidth: 250,
        imageHeight: 500,
        imageAlt: 'Custom image',
      })
    },
    removeBucket(str) {
      if (str.substring(0, 6) == "images") {
        return str.substring(9);
      } else {
        return str;
      }
    }, formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return '0';
    },
    filterBadge() {
      let badgeCount = 0;
      badgeCount += [this.contentType].filter(status => status != null).length;
      this.dataBadge = this.contentType !== 'all' && badgeCount > 0 ? badgeCount : null;
    },
   
    baseAlert(data) {
      this.$swal({
        icon: data.icon,
        title: data.title,
        text: data.text,
      })
    },
    actionGetSingle() {
      let email = this.user;
      let payload = {
        page: this.currentPage = 1,
        limit: this.perPage,
        premium: this.contentType,
        selectAll:true,
        email,
      };
      this.fetchSingle(payload);
      this.filterBadge()
    },

    filter() {
    this.$emit('handle-filter',this.contentType);
    this.filterBadge()
  }
  },
};
</script>

<style>
#previewImageStyle {
  width: 0%;
  height: 0%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

#previewImageStyle:hover {
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #9CA3AF;
  border-radius: 40px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 22px;
  background: #fff;
  border-radius: 50%;
  left: 0px;
  bottom: 0px;
  right: 0px;
  transition: 0.4s;
  border: 1px solid #ccc
}

.w-custom {
  width: 400px;
}

input[type="checkbox"].isToggleStatus:checked+.slider {
  background: #1A56DB !important;
}

input[type="checkbox"].isToggleStatus:checked+.slider:before {
  -webkit-transform: translateX(30px);
  -moz-transform: translateX(30px);
  transform: translateX(30px);
  left: -8px;
}
</style>